import { httpGet, httpPost, httpPatchMerge, httpDelete } from './http'
import type { ICompanyContact } from '~/types/company/models'
import type { TEntityId } from '~/types/models'
import { Contact } from '~/cynqueModules/dataObjects/Contact'

const apiEntityPath = '/api/companycontacts'

export async function getCompanyContacts({ apiPath = apiEntityPath } = {}) {
  const callingMn = getCompanyContacts.name
  return httpGet<ICompanyContact[]>({ callingMn, apiPath })
}

export async function getCompanyContactsPreProcessed({
  apiPath = apiEntityPath,
} = {}) {
  const callingMn = getCompanyContacts.name
  const rawCompanyContacts = await httpGet<ICompanyContact[]>({
    callingMn,
    apiPath,
  })
  return rawCompanyContacts.map((rawCompanyContact) =>
    Contact(rawCompanyContact)
  )
}

export async function createCompanyContact(entity: ICompanyContact) {
  const callingMn = createCompanyContact.name
  const apiPath = apiEntityPath
  return httpPost<ICompanyContact>({ callingMn, apiPath, entity })
}

export async function updateCompanyContact(
  entityData: Partial<ICompanyContact>,
  id: TEntityId
) {
  const callingMn = updateCompanyContact.name
  const apiPath = `${apiEntityPath}/${id}`
  type TPartialICompanyContact = Partial<ICompanyContact>
  return httpPatchMerge<TPartialICompanyContact>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function deleteCompanyContact(entityData: ICompanyContact) {
  const callingMn = deleteCompanyContact.name
  const apiPath = apiEntityPath
  return httpDelete<ICompanyContact>({
    callingMn,
    apiPath,
    entityData,
  })
}
